export default {
  DEVELOPERS_BANNER_HEIGHT: 72
};
